const DEFAULT_PROFILE_IMAGE =
  "https://cdn.filestackcontent.com/26Xc9cgQFmpVTv8h268V";
const DEFAULT_IMAGE = "https://www.filepicker.io/api/file/6pKABdZpStOVb1tcTGgA";

// we should refactor so that we don't need these consts set here like this
// it's quite terrible
const OS_DEFAULT_IMAGE =
  "https://cdn.outschool.com/outschool-filestack-migration/0wotKfsgR4iMbewMMtEJ_Placeholder.png";
// const OS_DEFAULT_PROFILE_IMAGE =
//   "https://cdn.outschool.com/outschool-filestack-migration/V7Iy0eR9CdpoHexqhqQj_avatar.png";

type ResizeOptions = {
  height?: number;
  h?: number;
  width?: number;
  w?: number;
  fit?: string;
};

// eventually we will want to just delete this version after we complete filestack migration
function filestackResizeString(options: ResizeOptions = {}) {
  const unroundedHeight = options.height ?? options.h;
  const unroundedWidth = options.width ?? options.w;
  const height = unroundedHeight ? Math.round(unroundedHeight) : false;
  const width = unroundedWidth ? Math.round(unroundedWidth) : false;

  const defaultResizeOptions = {
    fit: "crop",
  };

  const { w: _w, h: _h, ...optionsWithoutDimensions } = options;
  return Object.entries({
    ...defaultResizeOptions,
    ...optionsWithoutDimensions,
    width,
    height,
  })
    .map(([key, val]) => val && `${key}:${val}`)
    .filter(x => x)
    .sort()
    .join(",");
}

function resizeParams(options: ResizeOptions = {}) {
  const unroundedHeight = options.height ?? options.h;
  const unroundedWidth = options.width ?? options.w;
  const height = unroundedHeight ? Math.round(unroundedHeight) : false;
  const width = unroundedWidth ? Math.round(unroundedWidth) : false;

  const { w: _w, h: _h, ...optionsWithoutDimensions } = options;
  return Object.entries({
    ...optionsWithoutDimensions,
    width,
    height,
  })
    .map(([key, val]) => val && `${key}=${val}`)
    .filter(x => x)
    .sort();
}

type FilestackImageFormats = "jpg" | "pjpg" | "png" | "svg" | "webp";

export function osImageUrl(
  url?: string | null,
  options?: ResizeOptions,
  format: FilestackImageFormats = "jpg"
) {
  if (!url) {
    // This is the default "missing photo" image we show
    url = OS_DEFAULT_IMAGE;
    format = "png";
  }

  /*
    /images is not an actual path to s3 bucket, but something that 
    is used to trigger the image lambda. Once lambda reads this,
    it will then strip the /images to get the right path to the
    original image used for transformation

    if original was
    https://cdn.outschool.com/<s3path>
    then we want this to be
    https://cdn.outschool.com/images/<s3path>
  */
  const originalUrl = new URL(url); // parses host, pathname, etc.
  originalUrl.pathname = `/images${originalUrl.pathname}`;
  const osCdnUrl = originalUrl.toString();

  const resize =
    options && (options.width || options.height || options.w || options.h)
      ? resizeParams(options)
      : [];

  const transformParams = [
    ...resize,
    // strip:true removes metadata information from the photo
    "quality=80",
    "strip=true",
    `format=${format}`,
  ];

  return `${osCdnUrl}?${transformParams.join("&")}`;
}

export function imageUrl(
  url?: string | null,
  options?: ResizeOptions,
  format: FilestackImageFormats = "jpg"
) {
  let fileStackUrl =
    "https://process.filepicker.io/APHE465sSbqvbOIStdwTyz/rotate=deg:exif";

  if (!url) {
    // This is the default "missing photo" image we show
    url = DEFAULT_IMAGE;
    format = "png";
  }

  if (options && (options.width || options.height || options.w || options.h)) {
    const resize = filestackResizeString(options);
    fileStackUrl += `/resize=${resize}`;
  }

  // strip:true removes metadata information from the photo
  fileStackUrl += `/output=quality:80,compress:true,strip:true,format:${format}/cache=expiry:max/${url}`;

  return fileStackUrl;
}

export function videoThumbnailUrl(
  url: string,
  options: ResizeOptions,
  format: FilestackImageFormats = "jpg"
) {
  const resize = filestackResizeString(options);
  return `https://process.filepicker.io/APHE465sSbqvbOIStdwTyz/rotate=deg:exif/resize=${resize}/modulate=brightness:60/watermark=file:z90DIZ8PQmmN0DTt0LQG,size:60/output=quality:80,compress:true,strip:true,format:${format}/cache=expiry:max/${url}`;
}

// Currently using: 125 x 125 full size, 60x60 in featured cards and header (shown as 30x30)
export function headshotImageUrl(
  url: string | undefined | null,
  size: number = 125
) {
  return url
    ? imageUrl(url, { w: size, h: size, fit: "crop" })
    : imageUrl(DEFAULT_PROFILE_IMAGE, { w: size, h: size, fit: "crop" }, "png");
}

export function filestackPreviewUrl(fileUrl: string) {
  return `https://process.filestackapi.com/APHE465sSbqvbOIStdwTyz/output=format:pdf/${fileUrl}`;
}

export const HOMEPAGE_PREVIEW_IMAGE =
  "https://cdn.filestackcontent.com/gTGLqGaURguESvO9kgxe";

export function getS3ImagePath(s3path: string, cdn: string) {
  const pathWithBucket = s3path.includes("outschool-filestack-migration")
    ? s3path
    : `outschool-filestack-general/${s3path}`;
  return `https://${cdn}/${pathWithBucket}`;
}
